export class Constant {
  public static getHttpsBaazarHost(): string {
    return 'https://api.baazar.ir/';
  }
}
